/*global google */
import React, { useState, useEffect, useCallback } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  InfoWindow,
  Marker,
} from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import { CGU } from "../CGU/CGU.jsx";
import "intro.js/introjs.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeflex/primeflex.css";
import { OverlappingMarkerSpiderfier } from "npm-overlapping-marker-spiderfier/lib/oms.min";
import { Button } from "primereact/button";
import mapStyle from "./mapStyle";
import { Steps } from "intro.js-react";
import "./GMap.css";
import { useActif } from "../../Context/ActifContext";
import { useClient } from "../../Context/ClientContext";
import { useUser } from "../../Context/UserContext.js";
import { useQuery } from "react-query";
import fetchActifByClient from "../../Data/actif_service.js";
import { Dialog } from "primereact/dialog";
import { instance } from "../../api/index.js";
import { adminUser } from "../NavBar/navBar.jsx";
const containerStyle = {
  width: "100%",
  height: "85vh",
  position: "absolute",
};

const GMapActif = () => {
  const [openDialogCGU, setDialogCGU] = useState(false);
  const [map, setMap] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [enabledSteps, setEnabled] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [setDialog] = useState(false);
  const [oms, setOms] = useState(null);
  const { actifs, setActifAttributes, setSelectedActif } = useActif();
  const { client } = useClient();
  const selectedClient = JSON.parse(localStorage.getItem("selectedClient"));
  const { user, setUserAttributes } = useUser();
  let center;
  const navigate = useNavigate();
  const [cguContent, setCGUContent] = useState(""); // Holds the content of the CGU
  const [cguVersion, setCGUVersion] = useState(null); // Holds the version of the CGU


  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDZ_LWyM4XMceehwsRkVMahiVxHjOLN4Kg",
    scriptOptions: {
      async: true,
    },
  });

  const { refetch } = useQuery(
    ["actifData", selectedClient],
    () => fetchActifByClient(setActifAttributes, selectedClient),
    {
      enabled: !!selectedClient,
      onSuccess: () => {
        // This will be called after successful refetch
      },
    }
  );
 
  
  

  // const handleActiveMarker = (marker) => {
  //   if (marker === activeMarker) {
  //     return;
  //   }
  //   setActiveMarker(marker);
  // };

  useEffect(() => {
    refetch();
  }, [selectedClient, refetch]);

  useEffect(() => {
    if (actifs) {
      const feedItems = Object.values(actifs)?.map((el) => ({
        actif: el,
        id: el.id_actif_gexpertise,
        adresseRue1: el.adresse_rue1,
        adressVille: el.adresse_ville,
        adressPays: el.adresse_pays,
        position: { lat: el.lat, lng: el.lon },
        image: el.photo,
        lat: el.lat,
        long: el.lon,
        description: el.description,
        reference: el.reference_client,
        nom: el.nom,
        code: el.adresse_cp,
      }));
      setMarkers(feedItems);
    }
  }, [actifs]);




// Fetch latest CGU version and store it globally
const fetchLatestCGUVersion = async () => {
  try {
    const response = await instance.get("/api/pages/cgu/latest");
    if (response.data?.version) {
      setCGUVersion(response.data.version); // Set the latest CGU version
   
      return response.data.version; // Return version for use
    } else {
      
      return null;
    }
  } catch (error) {
   
    return null;
  }
};

// Verify if the popup should be shown
const verifyCGU = async (version) => {
  if (!version) {

    return;
  }

  try {
    const response = await instance.post("/api/utilisateurs/firstseen", {
      cgu_version: version,
    });

    if (response.data?.show_popup) {
      setDialogCGU(true); // Show popup

      
    } else {
      setDialogCGU(false); // Hide popup
     
    }
  } catch (error) {
    
  }
};

// Accept CGU logic
const handleAcceptCGU = async () => {
 

  if (!cguVersion || isNaN(cguVersion)) {
    
    return;
  }

  try {
    const response = await instance.post("/api/utilisateurs/acceptcgu", {
      cgu_version: cguVersion,
    });

  

    // Ensure the popup is closed after acceptance
    setDialogCGU(false);
    setEnabled(true);
  } catch (error) {

  }
};

// UseEffect for initial fetch and verification
useEffect(() => {
  const initializeCGU = async () => {
    const latestVersion = await fetchLatestCGUVersion();
    if (latestVersion) {
      await verifyCGU(latestVersion);
    }
  };

  initializeCGU();
}, []); // Run only once on mount

  
 
  


  const onLoad = useCallback(
    function callback(map) {
      const newOms = new OverlappingMarkerSpiderfier(map, {
        markersWontMove: false,
        markersWontHide: false,
        basicFormatEvents: false,
        keepSpiderfied: true,
        ignoreMapClick: true,
      });
      setOms(newOms);
    },
    []
  );

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  {/*useEffect(() => {
    if (isLoaded && map && oms && actifs.length > 0) {
      const newMarkers = actifs.map((el) => {
        const position = { lat: el.lat, lng: el.lon };
        const marker = new window.google.maps.Marker({
          position,
          map,
          title: el.nom,
        });
        oms.addMarker(marker);
        marker.addListener("click", () => setActiveMarker(el.id_actif_gexpertise));
        return { id: el.id_actif_gexpertise, marker, position };
      });
      setMarkers(newMarkers);

      const bounds = new window.google.maps.LatLngBounds();
      newMarkers.forEach(({ position }) => {
        bounds.extend(position);
      });
      map.fitBounds(bounds);
    }
  }, [isLoaded, map, oms, actifs]);*/}
  useEffect(() => {
  if (map && markers.length > 0) {
    const bounds = new window.google.maps.LatLngBounds();
    markers.forEach(({ position }) => {
      bounds.extend(position);
    });
    map.fitBounds(bounds);
  }
}, [map, markers]);

  if (actifs?.length !== 0) {
    center = { lat: parseFloat(actifs[0].lat), lng: parseFloat(actifs[0].lon) };
  }

  let steps = [
    {
      element: "#maps",
      intro: 'Cliquez sur un actif pour accéder aux livrables associés <img src="tuto_marker.PNG" width="75%" height="30%"/>',
      position: "top",
    },
    {
      element: ".searchBox",
      intro: "Recherchez un actif par mot clé ",
      position: "bottom",
    },
    {
      element: ".carto",
      intro: "Visualisez les actifs en mode cartographie ",
      position: "left",
    },
    {
      element: ".actifList",
      intro: "Visualisez les actifs en mode liste",
      position: "left",
    },
    {
      element: ".portail",
      intro: "Accédez au Portail urbanisme du Groupe Gexpertise",
      position: "left",
    },
    {
      element: ".NameLastName",
      intro: "Accédez à votre profil et à la liste des utilisateurs qui ont accès au compte GexOnline",
      position: "right",
    },
    {
      element: ".nousContacter",
      intro: "Contactez nous via les formulaires disponibles",
      position: "right",
    },
  ];

  const clientTableau = Object.values(client);
  if (!adminUser(clientTableau, selectedClient)) {
    steps = steps.filter((item) => item.element !== ".portail");
  }
  const onExit = () => {
    setEnabled(false);
    setDialog(false);
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          label="Accepter"
          style={{ backgroundColor: "#DE0737", borderColor: "#DE0737" }}
          onClick={handleAcceptCGU} 
        />
      </div>
    );
  };
  const handleMarkerClick = (markerId) => {
  setActiveMarker(markerId);
};

  return (
    <>
      <Steps
        enabled={enabledSteps}
        steps={steps}
        initialStep={0}
        onExit={onExit}
        options={{
          nextLabel: "Suivant",
          prevLabel: "Précedent",
          doneLabel: "Terminer",
        }}
      />

      {openDialogCGU && (
        <Dialog
          visible={openDialogCGU}
          style={{ width: "75vw" }}
          closeOnEscape={false}
          closable={false}
          
            footer={renderFooter()}
        
    >
        
        <CGU />
        </Dialog>
      )}
      {selectedClient && isLoaded && (
        <GoogleMap
          id="maps"
          mapContainerStyle={containerStyle}
          center={center}
          zoom={6}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            disableDefaultUI: true,
            zoomControl: true,
            styles: mapStyle.GexMap,
            zoomControlOptions: {
              position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            gestureHandling: "greedy",
            mapTypeControl: true,
            mapTypeControlOptions: {
              style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: window.google.maps.ControlPosition.TOP_LEFT,
              mapTypeIds: [
                window.google.maps.MapTypeId.TERRAIN,
                window.google.maps.MapTypeId.SATELLITE,
                window.google.maps.MapTypeId.styles,
              ],
            },
            streetViewControl: false,
            fullscreenControl: false,
          }}
        >
          {actifs &&
            markers &&
            selectedClient &&
            markers.map(
              ({
                actif,
                id,
                position,
                image,
                adresseRue1,
                adressVille,
                adressPays,
                lat,
                long,
                description,
                reference,
                code,
                nom,
              }) => (
                <Marker
                  key={id}
                  position={position}
                  onClick={() => handleMarkerClick(id)} 
                  onLoad={(marker) => {
                    if (oms) {
                      oms.addMarker(marker);

                      window.google.maps.event.addListener(
                        marker,
                        "spider_click",
                        () => {
                          //setActiveMarker(id);
                           handleMarkerClick(id); 
                        }
                      );
                    }
                  }}
                >
                  {activeMarker === id && (
                    <InfoWindow
                      className="inforWindow"
                      options={{ maxWidth: 200 }}
                      onCloseClick={() => setActiveMarker(null)}
                    >
                      <>
                        <div style={{ position: "relative" }}>
                          {/*<img
                            src="../../default_actif.png"
                            alt="actif"
                            className="imgActif"
                          />*/}
                          <p style={{
                            color: "rgb(10 10 10 / 87%)",
                            paddingLeft: "9%",
                            
                          }} >{reference}</p>
                        </div>
                        <div
                          style={{
                            color: "#DE0737",
                            fontSize: "16",
                            fontWeight: "500",
                            paddingLeft: "9%",
                          }}
                        >
                          {adresseRue1}
                        </div>
                        <div
                          style={{
                            color: "rgba(0,0,0,.54)",
                            paddingLeft: "9%",
                          }}
                        >
                          {adressVille}, {adressPays} <br />
                          {code}
                        </div>
                        <Button
                          label="Voir l'actif"
                          className="btn-ActifMap"
                          onClick={(e) => {
                            setSelectedActif(actif);
                            navigate("/detail");
                          }}
                          id={id}
                        ></Button>
                      </>
                    </InfoWindow>
                  )}
                </Marker>
              )
            )}
        </GoogleMap>
      )}
    </>
  );
};
export default GMapActif;

